import { defineStore } from "pinia";
import SettingResource from "~/models/systems-manager/Setting";
import SystemResource from "~/models/systems-manager/System";
import ConnectionResource from "~/models/systems-manager/Connection";
import EmailTemplateResource from "~/models/systems-manager/EmailTemplate";

const getSettingValue = (value) => {
  if (value === null || value === true || value === false || value === "") {
    return value;
  }
  if (!isNaN(Number(value))) {
    return Number(value);
  }

  return value;
};

export const useSystemsManagerStore = defineStore("systemsmanager", {
  state: () => ({
    settings: [],
    settings_schema: [
      {
        field_type: "QInput",
        name: "system_file_path",
        empty_value: "",
        setup: {
          label: "System File Path",
        },
      },
      {
        field_type: "QInput",
        name: "bin_path",
        empty_value: "",
        setup: {
          label: "Bin Path",
        },
      },
      {
        field_type: "QInput",
        name: "command_types",
        empty_value: "",
        setup: {
          label: "Command Types (csv)",
        },
      },
      {
        field_type: "QInput",
        name: "connection_types",
        empty_value: "",
        setup: {
          label: "Connection Types (json)",
        },
      },
      {
        field_type: "QInput",
        name: "default_google_api_account",
        empty_value: "",
        setup: {
          label: "Default Google API Account (leyden212.org)",
        },
      },
      {
        field_type: "QInput",
        name: "default_google_api_student_account",
        empty_value: "",
        setup: {
          label: "Default Google API Account (student.leyden212.org)",
        },
      },
    ],
    system_file_path: null,
    bin_path: null,
    command_types: null,
    connection_types: null,
    default_google_api_account: null,
    default_google_api_student_account: null,
    // End DB Settings
    loading_systems: false,
    systems: [],
    loading_connections: false,
    connections: [],
    loading_email_templates: false,
    email_templates: [],
  }),
  getters: {
    getOptionsSystems() {
      if (!this.systems || this.systems.length === 0) {
        return [];
      }
      return this.systems.map((system) => {
        return {
          label: system.name,
          value: system.id,
        };
      });
    },
    getOptionsConnections() {
      if (!this.connections || this.connections.length === 0) {
        return [];
      }
      return this.connections.map((connection) => {
        return {
          label: connection.name,
          value: connection.id,
        };
      });
    },
    getOptionsConnectionTypes() {
      if (!this.connection_types) {
        return [];
      }
      return Object.entries(this.connection_types).map((cType) => {
        return {
          value: cType[0],
          label: cType[1],
        };
      });
    },
    getOptionsCommandTypes() {
      if (!this.command_types) {
        //|| this.systems.length === 0
        return [];
      }
      return this.command_types;
    },
  },
  actions: {
    setSettings(settings) {
      this.settings = settings;
      settings.forEach((setting) => {
        this[setting.name] = getSettingValue(setting.value);
      });
    },
    async loadConfig() {
      this.loading_systems = true;
      const response = await SettingResource.all();
      this.setSettings(response.data);
      this.command_types = response.command_types;
      this.connection_types = response.connection_types;
      this.systems = response.systems.map((i) => new SystemResource(i));
      this.email_templates = response.email_templates.map(
        (i) => new EmailTemplateResource(i)
      );
      this.connections = response.connections.map(
        (i) => new ConnectionResource(i)
      );
      this.loading_systems = false;
    },

    /**
     *  Handle Changes to Related Data
     **/
    updateRelatedData(model, myKey, matchFn) {
      if (typeof this[myKey] != "object" || !Array.isArray(this[myKey])) {
        // Don't care about save.
        return;
      }

      const dataIndex = this[myKey].findIndex(matchFn);
      if (dataIndex == -1) {
        this[myKey].push(model);
      } else {
        Object.assign(this[myKey][dataIndex], model);
        //this[myKey].splice(dataIndex, 1, model);
      }
    },

    removeRelatedData(model, myKey, matchFn) {
      if (typeof this[myKey] != "object" || !Array.isArray(this[myKey])) {
        // Don't care about save.
        return;
      }

      const dataIndex = this[myKey].findIndex(matchFn);
      if (dataIndex != -1) {
        this[myKey].splice(dataIndex, 1);
      }
    },

    setSystemFromUpdate(updatedSystem) {
      this.updateRelatedData(
        new SystemResource(updatedSystem),
        "systems",
        (s) => s.id == updatedSystem.id
      );
      /*
      const index = this.systems.findIndex((oldSystem) => {
        return oldSystem.id == updatedSystem.id;
      });
      if (index === -1) {
        this.systems.push(new SystemResource(updatedSystem));
      } else {
        Object.assign(this.systems[index], updatedSystem);
        //this.systems.splice(index, 1, updatedSystem);
      }
      */
      return;
    },

    updateConnection(model) {
      this.updateRelatedData(model, "connections", (m) => m.id == model.id);
    },

    removeConnection(model) {
      this.removeRelatedData(model, "connections", (m) => m.id == model.id);
    },

    updateEmailTemplate(model) {
      this.updateRelatedData(model, "email_templates", (m) => m.id == model.id);
    },

    removeEmailTemplate(model) {
      this.removeRelatedData(model, "email_templates", (m) => m.id == model.id);
    },
  },
});
